document.addEventListener("DOMContentLoaded", function () {
  /* ── Accordion ────────────────────────────────────────────── */
  var atTitles = document.querySelectorAll(".acctitle");
  atTitles.forEach(function (atTitle) {
    atTitle.addEventListener("click", function () {
      var atTab = this.nextElementSibling;
      var isActive = this.classList.contains("active");

      var parent = this.parentElement;
      var siblings = parent.parentNode.children;
      for (var i = 0; i < siblings.length; i++) {
        var siblingTab = siblings[i].querySelector(".acccontent");
        siblingTab.style.maxHeight = null;
        siblings[i].querySelector(".acctitle").classList.remove("active");
        siblings[i].classList.remove("currentopen");
      }

      if (!isActive) {
        this.classList.add("active");
        parent.classList.add("currentopen");
        atTab.style.maxHeight = atTab.scrollHeight + "px";
      }
    });
  });

  /* ── Swiper Initializations (config-driven) ───────────────── */
  var swiperConfigs = [
    /* home banner – full */
    {
      selector: ".home-banner-slider-full",
      config: {
        direction: "vertical",
        effect: "slide",
        speed: 20000,
        slidesPerView: 2,
        spaceBetween: 3,
        loop: true,
        autoplay: { delay: 1, disableOnInteraction: false },
        breakpoints: {
          575: { slidesPerView: 1, spaceBetween: 5, loop: true },
        },
      },
    },
    /* home banner – reverse */
    {
      selector: ".reverse-direction",
      config: {
        direction: "vertical",
        effect: "slide",
        speed: 18000,
        slidesPerView: 2,
        spaceBetween: 3,
        loop: true,
        autoplay: { delay: 1, reverseDirection: true, disableOnInteraction: false },
        breakpoints: {
          575: { slidesPerView: 2, spaceBetween: 5 },
        },
      },
    },
    /* home banner – default */
    {
      selector: ".home-banner-slider",
      config: {
        direction: "vertical",
        effect: "slide",
        speed: 20000,
        slidesPerView: 2,
        spaceBetween: 3,
        loop: true,
        autoplay: { delay: 1, reverseDirection: false, disableOnInteraction: false },
        breakpoints: {
          575: { slidesPerView: 2, spaceBetween: 5 },
        },
      },
    },
    /* joga section slider */
    {
      selector: ".joga-sec-slider",
      config: {
        speed: 3000,
        autoplay: { delay: 2000 },
        breakpoints: {
          991: { slidesPerView: 3, spaceBetween: 0, loop: false, centeredSlides: false },
          0: { slidesPerView: 2.5, spaceBetween: 0, loop: true, centeredSlides: true },
        },
        on: {
          slideChange: function () {
            setTimeout(updateActiveClass, 2000);
          },
          init: function () {
            setTimeout(updateActiveClass, 2000);
          },
        },
      },
    },
    /* approved slider */
    {
      selector: ".approved-slider",
      config: {
        navigation: { nextEl: ".switchslider-next", prevEl: ".switchslider-prev" },
        loop: true,
        centeredSlides: false,
        breakpoints: {
          992: { slidesPerView: 4, spaceBetween: 15, loop: false },
          600: { slidesPerView: 3, spaceBetween: 15 },
          0: { slidesPerView: 1, spaceBetween: 30, loop: true, centeredSlides: true },
        },
      },
    },
    /* hall slider */
    {
      selector: ".hall-slider",
      config: {
        centeredSlides: true,
        navigation: { nextEl: ".hallslider-next", prevEl: ".hallslider-prev" },
        loop: true,
        slidesPerView: 2,
        paginationClickable: true,
        spaceBetween: 0,
        breakpoints: {
          768: {
            slidesPerView: 3,
            spaceBetween: 25,
            centeredSlides: false,
            loop: false,
            scrollbar: { el: ".hall-scroll", draggable: true },
          },
          0: {
            slidesPerView: 2.5,
            centeredSlides: true,
            spaceBetween: 0,
            loop: true,
            pagination: { el: ".hall-dots", clickable: true },
          },
        },
      },
    },
    /* switch-joga slider */
    {
      selector: ".switch-joga-slider",
      config: {
        loop: true,
        navigation: { nextEl: ".switchslider-next", prevEl: ".switchslider-prev" },
        slidesPerView: 2,
        paginationClickable: true,
        spaceBetween: 32,
        scrollbar: { el: ".switchjoga-scroll", draggable: true },
        breakpoints: {
          1024: { slidesPerView: 5 },
          768: { slidesPerView: 3, loop: false },
          0: { slidesPerView: 2, spaceBetween: 0, centeredSlides: true },
        },
      },
    },
    /* video review slider */
    {
      selector: ".video-review-slider",
      config: {
        loop: true,
        navigation: { nextEl: ".videoslider-next", prevEl: ".videoslider-prev" },
        slidesPerView: 2,
        paginationClickable: true,
        spaceBetween: 32,
        scrollbar: { el: ".videojoga-scroll", draggable: true },
        breakpoints: {
          1024: { loop: true, slidesPerView: 5 },
          768: { slidesPerView: 3 },
          0: { slidesPerView: 2, spaceBetween: 0, centeredSlides: true },
        },
      },
    },
    /* featured tab slider */
    {
      selector: ".featured-tab-slider",
      config: {
        loop: true,
        navigation: { nextEl: ".swiper-tab-next", prevEl: ".swiper-tab-prev" },
        scrollbar: { el: ".swiper-tab-scrollbar", draggable: true },
        slidesPerView: 1,
        paginationClickable: true,
        spaceBetween: 0,
        breakpoints: {
          1280: { slidesPerView: 4, spaceBetween: 32 },
          991: { slidesPerView: 3, spaceBetween: 24 },
          749: { slidesPerView: 2, spaceBetween: 20 },
          480: { slidesPerView: 1, spaceBetween: 0 },
        },
      },
    },
    /* you may also like slider */
    {
      selector: ".featured-also-like-slider",
      config: {
        loop: true,
        navigation: { nextEl: ".swiper-also-like-next", prevEl: ".swiper-also-like-prev" },
        scrollbar: { el: ".swiper-also-like-scrollbar", draggable: true },
        slidesPerView: 1,
        paginationClickable: true,
        spaceBetween: 0,
        breakpoints: {
          1280: { slidesPerView: 4, spaceBetween: 32 },
          991: { slidesPerView: 3, spaceBetween: 24 },
          749: { slidesPerView: 2, spaceBetween: 20 },
          480: { slidesPerView: 1, spaceBetween: 0 },
        },
      },
    },
    /* review style 1 slider */
    {
      selector: ".review-slider-style-1",
      config: {
        loop: true,
        navigation: { nextEl: ".reviewstyle1slider-next", prevEl: ".reviewstyle1slider-prev" },
        slidesPerView: 2,
        paginationClickable: true,
        spaceBetween: 19,
        scrollbar: { el: ".reviewstyle1slider-scroll", draggable: true },
        breakpoints: {
          1024: { slidesPerView: 4, loop: true },
          768: { slidesPerView: 2, loop: false },
          0: { slidesPerView: 1.1, spaceBetween: 10, centeredSlides: true },
        },
      },
    },
    /* announcement bar slider */
    {
      selector: ".top-announcement-bar .text-slider-row",
      config: {
        loop: true,
        slidesPerView: 1,
        spaceBetween: 0,
        speed: 3000,
        autoplay: { delay: 5000 },
        breakpoints: {
          0: { slidesPerView: 1, spaceBetween: 0 },
        },
      },
    },
    /* text slider style 1 */
    {
      selector: ".text-slider-sec .text-slider-row",
      config: {
        loop: true,
        navigation: { nextEl: ".textslider-next", prevEl: ".textslider-prev" },
        slidesPerView: 1,
        paginationClickable: true,
        spaceBetween: 10,
        breakpoints: {
          1024: { slidesPerView: 1 },
          768: { slidesPerView: 1 },
          0: { slidesPerView: 1, spaceBetween: 10, centeredSlides: true },
        },
      },
    },
  ];

  swiperConfigs.forEach(function (item) {
    if (document.querySelector(item.selector)) {
      new Swiper(item.selector, item.config);
    }
  });

  function updateActiveClass() {
    var slides = document.querySelectorAll(".joga-sec-slider .swiper-slide");
    slides.forEach(function (slide) {
      slide.classList.remove("active");
    });
    var activeSlide = document.querySelector(
      ".joga-sec-slider .swiper-slide.swiper-slide-active"
    );
    if (activeSlide) {
      activeSlide.classList.add("active");
    }
  }

  /* ── Helper: reload cart drawer ────────────────────────────── */
  function reloadCartDrawer() {
    var cartDrawerEl = document.querySelector("cart-drawer");
    if (!cartDrawerEl) return;
    fetch(location.href)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, "text/html");
        var fresh = doc.querySelector("#CartDrawer");
        if (fresh) {
          cartDrawerEl.innerHTML = fresh.outerHTML;
        }
        setTimeout(function () {
          cartDrawerEl.classList.remove("is-empty");
          cartDrawerEl.classList.add("active");
          document.body.classList.add("overflow-hidden");
        }, 500);
      });
  }

  /* ── Helper: add item to cart via AJAX ─────────────────────── */
  function addToCart(variantId, callback) {
    var formData = new FormData();
    formData.append("quantity", "1");
    formData.append("id", variantId);
    fetch("/cart/add.js", {
      method: "POST",
      body: formData,
    })
      .then(function (r) {
        return typeof parseFetchJson === "function" ? parseFetchJson(r) : r.json();
      })
      .then(function (data) {
        if (data && data.status) return;
        if (typeof notifyCartRefresh === "function") {
          notifyCartRefresh();
        }
        reloadCartDrawer();
        if (typeof callback === "function") {
          setTimeout(callback, 500);
        }
      })
      .catch(function () {});
  }

  /* ── Helper: vanilla slideToggle ───────────────────────────── */
  function slideToggle(el) {
    if (!el) return;
    if (el.style.display === "none" || getComputedStyle(el).display === "none") {
      el.style.display = "";
      el.style.overflow = "hidden";
      var height = el.scrollHeight;
      el.style.maxHeight = "0px";
      el.offsetHeight; // force reflow
      el.style.transition = "max-height 0.35s ease";
      el.style.maxHeight = height + "px";
      el.addEventListener("transitionend", function handler() {
        el.style.maxHeight = "";
        el.style.overflow = "";
        el.style.transition = "";
        el.removeEventListener("transitionend", handler);
      });
    } else {
      el.style.overflow = "hidden";
      el.style.maxHeight = el.scrollHeight + "px";
      el.offsetHeight; // force reflow
      el.style.transition = "max-height 0.35s ease";
      el.style.maxHeight = "0px";
      el.addEventListener("transitionend", function handler() {
        el.style.display = "none";
        el.style.maxHeight = "";
        el.style.overflow = "";
        el.style.transition = "";
        el.removeEventListener("transitionend", handler);
      });
    }
  }

  /* ── Free product option change ────────────────────────────── */
  document.addEventListener("change", function (e) {
    if (!e.target.matches(".option_item input")) return;

    var mainDiv = e.target.closest(".free_product_js");
    if (!mainDiv) return;

    var optionsFlex = mainDiv.querySelectorAll(".options_flex");
    var sizeInput = optionsFlex[0] ? optionsFlex[0].querySelector("input:checked") : null;
    var colorInput = optionsFlex[1] ? optionsFlex[1].querySelector("input:checked") : null;
    var size = sizeInput ? sizeInput.value : "";
    var color = colorInput ? colorInput.value : "";
    var title = size + " / " + color;

    var selectEl = mainDiv.querySelector('select[name="variant_id"]');
    if (!selectEl) return;

    var options = selectEl.querySelectorAll("option");
    options.forEach(function (opt) {
      if (opt.textContent === title) {
        selectEl.value = opt.value;
        selectEl.dispatchEvent(new Event("change", { bubbles: true }));
      }
    });
  });

  /* ── Variant select change (cart swap) ─────────────────────── */
  document.addEventListener("change", function (e) {
    if (!e.target.matches('select[name="variant_id"]')) return;

    var selectEl = e.target;
    var id = selectEl.value;
    var removeLink = selectEl.getAttribute("remove_link");
    var cartItem = selectEl.closest(".cart-item");

    if (cartItem) {
      var spinner = cartItem.querySelector(".loading__spinner");
      if (spinner) spinner.classList.remove("hidden");
    }

    fetch(removeLink, { method: "POST" })
      .then(function () {
        addToCart(id);
      });
  });

  /* ── Footer accordion (mobile) ─────────────────────────────── */
  document.addEventListener("click", function (e) {
    var heading = e.target.closest("body .footer-sec .footer-inner h3");
    if (!heading) return;

    heading.classList.toggle("active");
    slideToggle(heading.nextElementSibling);
  });

  /* ── Add-to-cart from custom drawer product box ────────────── */
  document.addEventListener("click", function (e) {
    var btn = e.target.closest(
      ".custom_drawer_products_item_buy_box .add_to_cart_ajax"
    );
    if (!btn) return;
    e.preventDefault();

    var buyBox = btn.closest(".custom_drawer_products_item_buy_box");
    if (!buyBox) return;

    var selectEl = buyBox.querySelector('select[name="variant_id_custom"]');
    if (!selectEl) return;

    addToCart(selectEl.value);
  });

  /* ── Add-to-cart from custom button ────────────────────────── */
  document.addEventListener("click", function (e) {
    var btn = e.target.closest(".custom_button .add_to_cart_ajax");
    if (!btn) return;
    e.preventDefault();

    var id = btn.getAttribute("variant_id");
    btn.classList.add("loading_hk");

    addToCart(id, function () {
      btn.classList.remove("loading_hk");
    });
  });

  /* ── Product option select (add to cart on change) ─────────── */
  document.addEventListener("change", function (e) {
    if (!e.target.matches(".product_option_select select")) return;
    e.preventDefault();

    var selectEl = e.target;
    var id = selectEl.value;
    var prevEl = selectEl.previousElementSibling;

    if (prevEl) prevEl.classList.add("loading_hk");

    addToCart(id, function () {
      if (prevEl) prevEl.classList.remove("loading_hk");
      selectEl.value = "";
    });
  });
});

/* ── Prevent default on anchor-hash links ────────────────────── */
document.addEventListener("click", function (e) {
  var link = e.target.closest('a[href="#"]');
  if (link) e.preventDefault();
});

/* ── PDP FAQ section – id-based scrolling ────────────────────── */
document.addEventListener("DOMContentLoaded", function () {
  document
    .querySelectorAll(".faq-section-block-tab")
    .forEach(function (element) {
      element.addEventListener("click", function (e) {
        e.preventDefault();
        e.stopPropagation();

        var href = element.getAttribute("href").substring(1);

        var targetSection = document.querySelector(
          '.faqs-sec.accordian_tab [id="' + href + '"]'
        );
        if (targetSection) {
          var targetPosition = targetSection.offsetTop;
          var offsetPosition = targetPosition - 100;

          window.scrollTo({
            top: offsetPosition,
            behavior: "smooth",
          });

          targetSection.classList.add("active");

          document
            .querySelectorAll(".faqs-sec.accordian_tab .faq-section")
            .forEach(function (section) {
              if (section !== targetSection) {
                section.classList.remove("active");
              }
            });
        }
      });
    });
});
